<template>
  <div id="app_footer">
    <div class="content_box">
      <div>
        抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适当游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
      </div>
      <div>
        Copyright © 2020-{{ nowYear }} Mizhougame.cn All Rights Reserved
      </div>
      <div class="nowYear_box">
        成都迷舟星峰文化传播有限公司版权所有©2020-{{ nowYear }}
      </div>
      <div>
        <a href="https://beian.miit.gov.cn/" class="record recordNum" target="_blank">蜀ICP备2022019663号-1</a>&nbsp;&nbsp;
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo" class="record" target="_blank">公安备案号：<span class="gongan">51019002005199</span></a>
      </div>
      <div class="record">客服电话：028-85218082</div>
    </div>
  </div>
</template>

<script>
export default {
    name:"Footer",
    data(){
        return{
            nowYear:new Date().getFullYear()
        }
    },
};
</script>

<style lang="scss" scoped>
#app_footer {
  background-color: #202020;
}
#app_footer .content_box {
  height: 100%;
  text-align: center;
  color: #fff;
  padding: 1.5rem 0;
  font-size: 14px;
}
#app_footer .content_box > div {
  padding: 0.2rem 0;
}
#app_footer .content_box .record {
  color: #ae80f7;
  text-decoration: underline;
}
@media screen and (max-width: 480px) {
  #app_footer {
    font-size: 14px;
  }
  #app_footer .content_box > div {
    padding: 0.1rem 0;
  }
}
.section > img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue